import { render } from "./Company.vue?vue&type=template&id=ffd4b722&scoped=true&ts=true"
import script from "./Company.vue?vue&type=script&lang=ts"
export * from "./Company.vue?vue&type=script&lang=ts"

import "./Company.vue?vue&type=style&index=0&id=ffd4b722&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffd4b722"]])

export default __exports__